export enum SavedRequestType {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
}
